import React from "react";
import { FaBook, FaEdit, FaExchangeAlt, FaNetworkWired } from "react-icons/fa";

function OrderMatching() {
  return (
    <>
      <div className="services-style-two-area default-padding">
        <div className="shape">
          <img
            src="assets/img/thumb/ai_optimized_img.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4 col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Services</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Key Features of an Order Book DEXs
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4">
              <div className="services-style-four-items">
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaBook size={40} />
                  </div>
                  <h4>Order Book Structure</h4>
                  <p>
                    An order book is a digital ledger that lists all current buy
                    (bid) and sell (ask) orders for a particular trading pair.
                    It displays the price and quantity of assets that traders
                    are willing to buy or sell.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaEdit size={40} />
                  </div>
                  <h4>Placing Orders</h4>
                  <p>
                    Users can place different types of orders; Limit Orders,
                    market orders or stop orders. Traders can specify a price at
                    which a trader is willing to buy or sell an asset at
                    predetermined marks.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaExchangeAlt size={40} />
                  </div>
                  <h4>Order Matching</h4>
                  <p>
                    The DEX matches buy and sell orders based on price and time
                    priority. When a buy order matches a sell order, a trade is
                    executed, and the assets are transferred directly between
                    the wallets of the involved parties.
                  </p>
                </div>

                <div className="services-style-four-item">
                  <div className="icon">
                    <FaNetworkWired size={40} />
                  </div>
                  <h4>Decentralization</h4>
                  <p>
                    Order Book DEXs operate without a central authority, meaning
                    users maintain control over their funds throughout the
                    trading process. Transactions are recorded on the
                    blockchain, ensuring transparency and security.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderMatching;
